var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileyHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 55.4615385,
    y1: 32.5,
    x2: 67,
    y2: 28,
    id: "Line-3",
    stroke: "#584139",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4BF48",
    cx: 41,
    cy: 41,
    r: 41
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F7D34D",
    cx: 38,
    cy: 40.5,
    rx: 38,
    ry: 37.5
  })), /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 33.5,
    x2: 20.5,
    y2: 26.5,
    id: "Line-5",
    stroke: "#594238",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 33,
    x2: 21.5,
    y2: 26.5,
    id: "Line-5",
    stroke: "#594238",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.5,
    y1: 33.5,
    x2: 60.5,
    y2: 26.5,
    id: "Line-5",
    stroke: "#594238",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 33,
    x2: 61.5,
    y2: 26.5,
    id: "Line-5",
    stroke: "#594238",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3828125,49.2714844 C50.1347656,66.609375 27.7134801,66.7069248 19,48",
    id: "Path-3",
    stroke: "#594238",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyHappy);
export default __webpack_public_path__ + "static/media/Smiley_happy.e097b05e7eced0d479d4e7c0f33c1b5a.svg";
export { ForwardRef as ReactComponent };